const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const staggerSelectors = [
  '.koketa-collection-card',
  '.koketa-product-card',
  '.koketa-review',
  '.koketa-location__panel',
  '.product-grid__item',
  '.koketa-trust__item',
  '.koketa-social-reel',
  '.koketa-faq__item',
  '.koketa-card'
];

const motionDirections = ['left', 'right', 'scale', 'up'];
const motionTextSelector = [
  ':scope > h1',
  ':scope > h2',
  ':scope > p',
  ':scope > header > *',
  ':scope > .koketa-shell > header > *',
  ':scope > .koketa-shell > .koketa-section-heading > *',
  ':scope > .koketa-reviews__header > *',
  ':scope > .koketa-location__intro > *',
  ':scope > .koketa-statement__inner > *'
].join(',');

const shouldSkipMotion = (element) => Boolean(
  element.closest('.koketa-conversion-section, koketa-cookie-consent, theme-drawer, dialog')
);

const prepareSection = (section) => {
  if (!section || section.dataset.koketaMotionPrepared === 'true' || shouldSkipMotion(section)) return;

  section.dataset.koketaMotionPrepared = 'true';
  const children = section.querySelectorAll(staggerSelectors.join(','));
  children.forEach((child, index) => {
    child.dataset.koketaRevealItem = '';
    child.style.setProperty('--koketa-reveal-order', index % 8);
    child.dataset.koketaMotionItem = motionDirections[index % motionDirections.length];
  });

  const textElements = section.querySelectorAll(motionTextSelector);
  textElements.forEach((element, index) => {
    if (element.closest('[data-koketa-reveal-item], dialog')) return;
    element.dataset.koketaMotionText = motionDirections[index % motionDirections.length];
    element.style.setProperty('--koketa-text-order', index % 6);
  });
};

const prepareMotionSections = (root = document) => {
  const shopifySections = root.querySelectorAll?.('#MainContent .shopify-section') || [];

  shopifySections.forEach((wrapper, index) => {
    if (wrapper.matches('.koketa-conversion-section') || wrapper.querySelector(':scope > .koketa-conversion')) return;
    const section = wrapper.querySelector(':scope > [data-koketa-reveal], :scope > section, :scope > article, :scope > div, :scope > koketa-faq, :scope > koketa-social-reels');
    if (!section || shouldSkipMotion(section)) return;
    section.dataset.koketaReveal = '';
    section.dataset.koketaMotion = motionDirections[index % motionDirections.length];
    prepareSection(section);
  });

  root.querySelectorAll?.('[data-koketa-reveal]').forEach((section, index) => {
    if (!section.dataset.koketaMotion) section.dataset.koketaMotion = motionDirections[index % motionDirections.length];
    prepareSection(section);
  });
};

prepareMotionSections();

if (reduceMotion.matches || !('IntersectionObserver' in window)) {
  document.querySelectorAll('[data-koketa-reveal]').forEach((element) => element.classList.add('is-visible'));
} else {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        entry.target.querySelectorAll('[data-koketa-reveal-item]').forEach((child) => child.classList.add('is-visible'));
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  document.querySelectorAll('[data-koketa-reveal]').forEach((element) => {
    observer.observe(element);
  });

  document.addEventListener('shopify:section:load', (event) => {
    prepareMotionSections(event.target);
    const section = event.target.querySelector?.('[data-koketa-reveal]') || event.target.closest?.('[data-koketa-reveal]');
    if (!section) return;
    observer.observe(section);
  });
}

const syncPageVisibility = () => {
  document.documentElement.classList.toggle('is-page-hidden', document.hidden);
};

document.addEventListener('visibilitychange', syncPageVisibility);
syncPageVisibility();

const prepareAutoLoops = (root = document) => {
  const loops = root.querySelectorAll?.('[data-koketa-auto-loop]') || [];

  if (reduceMotion.matches || !('IntersectionObserver' in window)) {
    loops.forEach((loop) => loop.classList.remove('is-loop-visible'));
    return;
  }

  const loopObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('is-loop-visible', entry.isIntersecting && !document.hidden);
      });
    },
    { threshold: 0.05 }
  );

  loops.forEach((loop) => loopObserver.observe(loop));
};

prepareAutoLoops();

document.addEventListener('shopify:section:load', (event) => {
  prepareAutoLoops(event.target);
});
